module.exports = __webpack_public_path__ + "img/otros.2ac78c29.png";